export default "__VITE_ASSET__DQ4g1p4K__"